<template>
  <section class="bg-gray-light">
    <div class="container">
      <div class="row my-3">
        <div class="col">
          <h1>{{ $t("translation.Lagence") }}</h1>
          <p v-html="$t('translation.lagence_txt')"></p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "account",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
section {
  padding-bottom: 50px;
  padding-top: 40px;
}
</style>
